import { useState } from 'react'
import { FiMessageCircle, FiArrowRight } from 'react-icons/fi'
import FaqItem from './FaqItem'
import { useFaqs } from '../../../hooks/useFaqs'
import { appUrl } from '@astro/config'

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0)
  const { faqs: faqList } = useFaqs()

  return (
    <section id="faq" className="relative overflow-hidden py-16 md:py-14 md:px-18 bg-linear-to-b from-background to-white font-normal">
      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="space-y-6 lg:sticky lg:top-28">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-secondary/50" />
                <span className="text-[10px] uppercase tracking-[0.4em] text-secondary">Knowledge Base</span>
              </div>
              <h2 className="font-cinzel text-3xl uppercase leading-tight text-primary md:text-4xl lg:text-5xl">
                Frequently Asked <span className="text-gradient-gold">Questions</span>
              </h2>
              <p className="max-w-sm text-sm leading-relaxed text-primary/55">
                Everything you need to know — clearly answered. Browse the common questions below.
              </p>
              <div className="rounded-2xl border border-border/50 bg-white/70 p-6 shadow-sm">
                <h3 className="font-cinzel text-base uppercase text-primary">Still have a question?</h3>
                <p className="mt-1.5 text-[13px] leading-relaxed text-primary/55">If it isn&apos;t covered here, our team is happy to help.</p>
                <a
                  href={appUrl("website", "contact")}
                  className="group mt-4 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-white shadow-lg shadow-primary/15 transition-all hover:bg-secondary"
                >
                  <FiMessageCircle size={18} />
                  Contact Us
                  <FiArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
                </a>
              </div>
            </div>
          </div>

          <div className="space-y-3 lg:col-span-8">
            {faqList.map((item, index) => (
              <FaqItem
                key={item.q}
                item={item}
                index={index}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex((cur) => (cur === index ? -1 : index))}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
